var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupervisor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43527",
    "data-name": "Group 43527",
    transform: "translate(-194 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16123",
    "data-name": "Rectangle 16123",
    width: 24,
    height: 24,
    transform: "translate(194 80)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Supervisor",
    transform: "translate(175.5 61.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3136",
    "data-name": "Ellipse 3136",
    cx: 1.78,
    cy: 1.78,
    r: 1.78,
    transform: "translate(28.72 20)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37247",
    "data-name": "Path 37247",
    d: "M183.119,144.983H176v-3.2a1.78,1.78,0,0,1,1.78-1.78h3.559a1.78,1.78,0,0,1,1.78,1.78Z",
    transform: "translate(-149.059 -114.661)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3137",
    "data-name": "Ellipse 3137",
    cx: 1.78,
    cy: 1.78,
    r: 1.78,
    transform: "translate(20 37.441)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3138",
    "data-name": "Ellipse 3138",
    cx: 1.78,
    cy: 1.78,
    r: 1.78,
    transform: "translate(28.72 37.441)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3139",
    "data-name": "Ellipse 3139",
    cx: 1.78,
    cy: 1.78,
    r: 1.78,
    transform: "translate(37.441 37.441)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37248",
    "data-name": "Path 37248",
    d: "M60,335.559v-1.78A1.78,1.78,0,0,1,61.78,332H75.661a1.78,1.78,0,0,1,1.78,1.78v1.78",
    transform: "translate(-38.22 -298.119)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3347",
    "data-name": "Line 3347",
    y2: 7.119,
    transform: "translate(30.5 30.322)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisor);
export default __webpack_public_path__ + "static/media/supervisor.c5e4fe3e8eed9ed59926ef4832d8aa83.svg";
export { ForwardRef as ReactComponent };